/**
 * ArgClaw Admin UI - Main Application
 * Business Verification Admin Dashboard
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';


import { AdminLayout } from './components/layout/AdminLayout';
import { DashboardPage } from './pages/DashboardPage';
import { VerificationQueuePage } from './pages/VerificationQueuePage';
import { VerificationDetailPage } from './pages/VerificationDetailPage';
import { AuditLogPage } from './pages/AuditLogPage';
import { ReviewersPage } from './pages/ReviewersPage';
import { SettingsPage } from './pages/SettingsPage';
import './styles/globals.css';

// Query client configuration
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error instanceof Error && 'status' in error) {
          const status = (error as { status: number }).status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
    },
    mutations: {
      retry: (failureCount) => failureCount < 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="verification" element={<VerificationQueuePage />} />
            <Route path="verification/:id" element={<VerificationDetailPage />} />
            <Route path="audit-log" element={<AuditLogPage />} />
            <Route path="reviewers" element={<ReviewersPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </BrowserRouter>
      
      
    </QueryClientProvider>
  );
}

export default App;
